(() => {
  const selectors = {
    header: '.header',
    announcementBar: '.announcement-bar',
    menu: '.headerMenu',
    menuItem: '.headerMenu__listItem',
    menuItemButton: '.listItem__title--js',
    grandList: '.content__grandList',
    childItem: '.listChild',
    bodyOverlay: '.bodyOverlay',
    body: 'body',
    childItemContent: '.content__listChild',
    mobileAccordionHandler: '.js-toggle-mobile-accordion',

    menuItemActiveClass: 'headerMenu__listItem--active',
    grandListActiveClass: 'content__grandList--active',
    bodyOverlayActiveClass: 'bodyOverlay--active',
    childItemActiveClass: 'listChild--active',
    accordionActiveClass: 'menu-drawer__heading--active',
    thirdLevelMenuActiveClass: 'menuDrawer__thirdList--active',
  }
  const header = document.querySelector(selectors.header);
  const menu = document.querySelector(selectors.menu);
  const menuItemArray = menu.querySelectorAll(selectors.menuItem);
  const menuItemButtonArray = menu.querySelectorAll(selectors.menuItemButton);
  const childItemArray = menu.querySelectorAll(selectors.childItem);
  const grandListArray = menu.querySelectorAll(selectors.grandList);
  const bodyOverlay = document.querySelector(selectors.bodyOverlay);
  const body = document.querySelector(selectors.body);
  const announcementBar = document.querySelector(selectors.announcementBar);
  const mobileAccordionHandlers = document.querySelectorAll(selectors.mobileAccordionHandler);

  document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  document.documentElement.style.setProperty('--header-announcement-height', `${header.offsetHeight + announcementBar?.offsetHeight}px`);

  // show second level menu if it exist
  function toggleSecondLevel(e) {
    const currentLink = e.currentTarget;
    
    if (e.type === 'mouseenter') {
      const currentActiveElement = document.querySelector(".headerMenu__listItem--active");

      currentLink.classList.add(selectors.menuItemActiveClass);
      bodyOverlay.classList.add(selectors.bodyOverlayActiveClass);

      if(currentActiveElement && e.currentTarget && currentActiveElement.dataset.handle != e.currentTarget.dataset.handle) {
        currentActiveElement.classList.remove(selectors.menuItemActiveClass);
      }

      // Cancel any existing delay timers
      if (currentLink.leaveTimer) {
        clearTimeout(currentLink.leaveTimer);
        currentLink.leaveTimer = null;
      }

      if (
        currentLink.querySelector(selectors.childItemContent)
        && !currentLink.querySelector(`.${selectors.childItemActiveClass}`)
      ) {
        currentLink.querySelector(selectors.childItemContent).click();
      }
    } else if (e.type === 'mouseleave') {
      // Set a timer to remove classes after 300ms
      currentLink.leaveTimer = setTimeout(() => {
        currentLink.classList.remove(selectors.menuItemActiveClass);
        bodyOverlay.classList.remove(selectors.bodyOverlayActiveClass);
      }, 300);
    }
  }
  // show third level menu if it exist
  function showThirdLevel(child) {
    const currentList = menu.querySelector(`[data-child-category=${child.dataset.category}]`);

    if (!child.classList.contains(selectors.childItemActiveClass)) {
      unCheckAllSecondLevel(childItemArray);

      if (currentList) {
        if (currentList.classList.contains(selectors.grandListActiveClass)) {
          currentList.classList.remove(selectors.grandListActiveClass);
          child.classList.remove(selectors.childItemActiveClass);
        } else {
          closeAllSecondList(grandListArray);
          currentList.classList.add(selectors.grandListActiveClass);
          child.classList.add(selectors.childItemActiveClass);
        }
      } else {
        closeAllSecondList(grandListArray);
      }
    }
  }
  //  close megamenu
  function closeAllList(menuItems) {
    bodyOverlay.classList.remove(selectors.bodyOverlayActiveClass);
    body.classList.remove('inactive');
    closeAllSecondList(grandListArray);

    menuItems.forEach(menuItem => {
      menuItem.classList.remove(selectors.menuItemActiveClass);
    });
  }
  // close 3rd level menu
  function closeAllSecondList(grandLists) {
    unCheckAllSecondLevel(childItemArray);

    grandLists.forEach(grandList => {
      grandList.classList.remove(selectors.grandListActiveClass);
    });
  }
  // remove all active class from second level link
  function unCheckAllSecondLevel(childItemArray) {
    childItemArray.forEach(child => {
      child.classList.remove(selectors.childItemActiveClass);
    });
  }
  // toggle accordions
  function toggleAccordions(e) {
    e.preventDefault();

    const currentLink = e.currentTarget;
    const currentList = currentLink.nextElementSibling;

    if (currentLink.classList.contains(selectors.accordionActiveClass)) {
      currentLink.classList.remove(selectors.accordionActiveClass);
      currentList.classList.remove(selectors.thirdLevelMenuActiveClass);
      currentList.style.height = `${currentList.scrollHeight}px`;
    } else {
      currentLink.classList.add(selectors.accordionActiveClass);
      currentList.classList.add(selectors.thirdLevelMenuActiveClass);
      currentList.style.height = `0px`;
    }
  }

  mobileAccordionHandlers.forEach((handler) => {
    handler.addEventListener('click', toggleAccordions);
  });

  menuItemButtonArray.forEach((button) => {
    button.addEventListener('mouseenter', toggleSecondLevel);
    button.addEventListener('mouseleave', toggleSecondLevel);
  });

  childItemArray.forEach(child => {
    child.addEventListener('click', (event) => {
      showThirdLevel(event.currentTarget);
    });

    child.addEventListener('mouseenter', (event) => {
      showThirdLevel(event.currentTarget);
    });
  });

  bodyOverlay.addEventListener('click', () => {
    closeAllList(menuItemArray);
  });

  window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + "px");
  });
})();
